import { defaultListFilters } from 'utils';

export const prevSplitDiff: FilterListDescriptor = {
  filter: defaultListFilters.none,
  sort: {
    calcOrderBy: (_name, _sortBy, options) => {
      if (!options) {
        return '';
      }
      const id = options.id;
      return `splits:id|prev_split_diff|checkpoint_id|${id}`;
    },
  },
};
